export interface Region {
  name: string;
  slug: string;
  zip: string;
  lat: number;
  lng: number;
  radiusMiles: number;
  radiusMinutes: number;
  tagline: string;
}

export const DEFAULT_REGION: Region = {
  name: "Lakewood Ranch",
  slug: "lakewood-ranch",
  zip: "34202",
  lat: 27.4015,
  lng: -82.3959,
  radiusMiles: 25,
  radiusMinutes: 30,
  tagline: "Lakewood Ranch & Surrounding Areas",
};

export const REGIONS: Region[] = [DEFAULT_REGION];

export function getRegionBySlug(slug: string): Region | undefined {
  return REGIONS.find((r) => r.slug === slug);
}
